'use strict';
import has from 'lodash/has';
import isNumber from 'lodash/isNumber';
import memoize from 'lodash/memoize';
import {GpsStatus} from '../../core-utilities/enums/GpsStatus';
import {calcTotalTime, mergeIntervals} from './intervalsUtils';
import {isLocCaptured, mergeLoc} from './locationUtils';

export * from './comparators';
export * from './intervalsUtils';
export * from './locationUtils';
export {TimerDurationStatus} from './TimerDurationStatus';

export const MINUTE = 60 * 1000;
export const HOUR = 60 * MINUTE;
export const DAY = 24 * HOUR;

export const ELAPSED_TIME_IDX = {
  DAY: 0,
  HOUR: 1,
  MIN: 2,
  SEC: 3,
};

export const calcElapsedTime = memoize(t => {
  if (!isNumber(t)) {
    return [0, 0, 0];
  } else {
    let d = Math.floor(t / DAY);
    let h = Math.floor((t - d * DAY) / HOUR);
    let m = Math.floor((t - d * DAY - h * HOUR) / MINUTE);
    let s = Math.floor((t - d * DAY - h * HOUR - m * MINUTE) / 1000);

    if (s === 60) {
      m++;
      s = 0;
    }
    if (m === 60) {
      h++;
      m = 0;
    }
    if (h === 24) {
      d++;
      h = 0;
    }

    return [d, h, m, s];
  }
});

/**
 * @param {ActiveTimer} existingItem
 * @param {UpdateSyncStatusPayload} payload
 * @return {ActiveTimer}
 */
export function syncModel(existingItem, payload) {
  const newIntervals = mergeIntervals(existingItem.intervals, payload.model.intervals);
  const newLast = newIntervals[newIntervals.length - 1];
  const newLoc = mergeLoc(existingItem.loc, payload.model.loc);
  const newItem = {
    ...existingItem,
    ...payload.model,
    intervals: newIntervals,
    startedAt: isNumber(newLast.end) ? null : newLast.start,
    endedAt: isNumber(newLast.end) ? newLast.end : null,
    totalTime: calcTotalTime(newIntervals),
    loc: newLoc,
    locCap: isLocCaptured(newLoc, existingItem.locCap || payload.model.locCap),
    syncStatus: void 0,
  };

  if (isGpsItem(existingItem) && !isStarted(newItem)) {
    newItem.gpsStatus = GpsStatus.STOPPED;
  }

  return newItem;
}

export function isGpsItem(item) {
  return has(item, 'gpsStatus') && item.gpsStatus !== GpsStatus.STOPPED;
}

export function isStarted(item) {
  return isNumber(item.startedAt);
}



// WEBPACK FOOTER //
// ./src/js/timers/utils/index.js